// Vendors
import React from 'react'

// Components
import { QrCodeScanner } from 'components/QrCodeScanner'

// Styles
import {
  Flex,
  Text,
  Modal,
  ModalBody,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  CircularProgress,
} from '@chakra-ui/react'

// Interfaces
export type ModalQrCodeScannerProps = {
  isOpen: boolean
  isLoading?: boolean
  onClose: () => void
  onScan: (data: string) => Promise<void>
}

export const ModalQrCodeScanner = (
  props: ModalQrCodeScannerProps
): JSX.Element => {
  /*
  |-----------------------------------------------------------------------------
  | Constants
  |-----------------------------------------------------------------------------
  |
  |
  */
  const { onScan, isOpen, onClose, isLoading = false } = props

  /*
  |-----------------------------------------------------------------------------
  | Renders
  |-----------------------------------------------------------------------------
  |
  |
  */
  return (
    <Modal size="xl" isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Escaneie o código</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex h="320" w="320" justifyContent="center">
            {isLoading ? (
              <>
                <CircularProgress
                  mr="2"
                  size="20px"
                  isIndeterminate
                  color="blue.500"
                />
                <Text>Validando ID...</Text>
              </>
            ) : (
              <QrCodeScanner onScan={onScan} />
            )}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
